import { render, staticRenderFns } from "./SystemAlertDisplay.vue?vue&type=template&id=2dcb85e2&scoped=true"
import script from "./SystemAlertDisplay.vue?vue&type=script&lang=js"
export * from "./SystemAlertDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb85e2",
  null
  
)

export default component.exports